<template>
	<div class=''>
		<Textarea name='description' class='transition-all duration-500 ease-in-out'
			rows='6'
			v-model:value='value.description'
			:textareaClass='["transition-all duration-500 ease-in-out", {
				"min-h-[577px]": size,
				"min-h-[134px]": !size,
			}]'
		/>
	</div>
</template>

<script>
	import Note from '~/models/note.js';

	export default {
		props: {
			size: Boolean,
			editing: {
				type: Object, default: null
			}
		},

		data() {
			return {
				value: Note.form(this.editing)
			}
		}
	}
</script>